import NextScript from 'next/script';

import { useGtmConfig } from '../../hooks/useGtmConfig';

interface Props {
    gtmData: {
        [key: string]: unknown;
    };
}

export function GTMScript({ gtmData }: Props) {
    const { id, serverHost } = useGtmConfig();

    return (
        <NextScript
            id="gtmScript"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
                __html: `window.dataLayer=window.dataLayer||[];window.dataLayer.push(${JSON.stringify(gtmData)});
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
j.async=true;j.src='https://${serverHost}/08iry9bm4dptzgv.js?awl='+i.replace(/^GTM-/, '')+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');`,
            }}
        />
    );
}
